<div class="cmps-cdk-d-flex cmps-cdk-h-100p cmps-cdk-w-100pct">
    <div class="cmps-cdk-pt-0dot25">
        <div class="cmps-ciw-user--image-wrapper">
            <div
                class="cmps-ciw-user--image"
                *ngIf="imageUrl != null"
            >
                <img
                    [src]="imageUrl"
                    alt=""
                />
            </div>
            <cmps-icon
                class="cmps-ciw-user--icon cmps-cdk-fill-blue-100"
                svgIcon="account-circle"
                *ngIf="imageUrl == null"
            ></cmps-icon>
        </div>
    </div>
    <div>
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._11276_QUICK_ACCESS | translate"
                    [cmpsOverlayTrigger]="userQuickAccessTpl"
                    placement="bottom-left"
                >
                    <!-- don't use cmpsIconButtonLabel -->
                    <span
                        class="cmps-cdk-font-bold cmps-cdk-font-size-14p cmps-cdk-color-blue-100"
                    >
                        <ng-content select=".cmps-ciw-user--name"></ng-content>
                    </span>
                    <cmps-icon svgIcon="chevron-down"></cmps-icon>
                </button>
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        _i18n._11277_SEARCH_FOR_USER | translate
                    "
                    (click)="search.emit($event)"
                >
                    <cmps-icon svgIcon="magnify"></cmps-icon>
                </button>
            </div>
        </div>
        <div class="cmps-cdk-pb-0dot5">
            <ng-content select=".cmps-ciw-user--labels"></ng-content>
            <ng-content select=".cmps-ciw-user--badges"></ng-content>
        </div>
    </div>
</div>

<ng-template
    let-overlay="overlay"
    #userQuickAccessTpl
>
    <cmps-quick-access
        [overlay]="overlay"
        (userSelect)="select.emit($event)"
    ></cmps-quick-access>
</ng-template>
